import { render, staticRenderFns } from "./EnterPasswordReset.vue?vue&type=template&id=cc8822a4&scoped=true"
import script from "./EnterPasswordReset.vue?vue&type=script&lang=js"
export * from "./EnterPasswordReset.vue?vue&type=script&lang=js"
import style0 from "./EnterPasswordReset.vue?vue&type=style&index=0&id=cc8822a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8822a4",
  null
  
)

export default component.exports